'use strict';

const Reflux = require('@muzzylane/reflux');
const find = require('lodash/find');
const forEach = require('lodash/forEach');
const reject = require('lodash/reject');
const cloneDeep = require('lodash/cloneDeep');

const Globals = require('../../../app/globals');
const ServerRequest = require('../actions/request');
const SignInStore = require('./SignInStore');
const ForgeError = require('../util/error');
const SignInActions = require('../actions/sign_in_actions');
const OrganizationActions = require('../actions/OrganizationActions');
const GlobalUserActions = require('../actions/GlobalUserActions');
const Credentials = require('../local_credentials');

let isAdmin = false;
let authors = [];
let orgs = [];
let ltiUsers = [];
let overviewStats = null;
let launchCounts = {};
let emulated3pUserInfo = {};
let userChannelRoles = {};
let lmsDeployments = {};

let initializedAuthors = false; // at least one page has been initialized
let initializedLtiUsers = false; // at least one page has been initialized
let initialized = false;
const userPaginationBase = {
    authors: {
        totalRecords: 0,
        searchTerm: '',
        currentPage: 1,
        numPages: 1,
        filterPages: 0,
        recordsPerPage: 0,
    },
    ltiUsers: {
        totalRecords: 0,
        searchTerm: '',
        currentPage: 1,
        numPages: 1,
        filterPages: 0,
        recordsPerPage: 0,
    },
    orgs: {
        totalRecords: 0,
        searchTerm: '',
        currentPage: 1,
        numPages: 1,
        filterPages: 0,
        recordsPerPage: 0,
    },
};

let userPagination = cloneDeep(userPaginationBase);

let initializedFeedbackComments = false; // at least one page has been initialized
let feedback_comments = [];
let studentFeedbackPaginationBase = {
    totalRecords: 0,
    commentSearchTerm: '',
    categorySearchTerm: '',
    sortBy: '',
    currentPage: 1,
    numPages: 1,
    filterPages: 0,
    recordsPerPage: 0,
};

let studentFeedbackPagination = cloneDeep(studentFeedbackPaginationBase);

let signedIn = false;
let action = {};
let error = {};

function signedIn3p() {
    const cookieValue = Credentials.getThirdPartyCredentials();
    return !!cookieValue;
}

const AdminGlobalUserStore = Reflux.createStore({
    listenables: [SignInActions, OrganizationActions, GlobalUserActions],

    init: function() {
        isAdmin = this.parseIsAdminFromSignInStoreState(SignInStore.getState());

        if (isAdmin && signedIn3p()) {
            this.getEmulatedUserInfo();
        }

        this.listenTo(SignInStore, this.onSignInChange);
    },

    resetState: function() {
        isAdmin = false;
        launchCounts = {}; // user owned activity play count total (per author / organization)
        authors = [];
        orgs = [];
        ltiUsers = [];
        overviewStats = null;
        initializedAuthors = false;
        initializedLtiUsers = false;
        initialized = false;
        signedIn = false;
        emulated3pUserInfo = {};
        userChannelRoles = {};
        userPagination = cloneDeep(userPaginationBase);
        lmsDeployments = {};
        initializedFeedbackComments = false;
        studentFeedbackPagination = cloneDeep(studentFeedbackPaginationBase);
        feedback_comments = [];
    },

    onSignInChange: function(state)  {
        isAdmin = this.parseIsAdminFromSignInStoreState(state);
        if (isAdmin && signedIn3p()) {
            this.getEmulatedUserInfo();
        }
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    getState: function() {
        return {
            initialized: initialized,
            authors: authors,
            orgs: orgs,
            ltiUsers: ltiUsers,
            overviewStats: overviewStats,
            launchCounts: launchCounts,
            emulated3pUserInfo: emulated3pUserInfo,
            userChannelRoles: userChannelRoles,
            action: action,
            userPagination: userPagination,
            lmsDeployments: lmsDeployments,
        };
    },

    getFeedbackCommentState: function() {
        return {action,initializedFeedbackComments,feedback_comments,studentFeedbackPagination};
    },
    
    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
        //error = {}; //maybe?
    },

    parseIsAdminFromSignInStoreState: function(state) {
        if (state.initializedLocal && state.userInfo && state.userInfo.admin) {
            return true;
        }

        return false;
    },

    updateUserBanHistory: function(user_id) {
        const self = this;
        ServerRequest.makeRequest(`/authoring/user/${user_id}/ban_history`, 'GET')
        .then(function(res) {
            let author = find(authors,{id:user_id});
            let ltiUser = find(ltiUsers,{id:user_id});
            if (author) {
                author.ban_history = res;
            }

            if (ltiUser) {
                ltiUser.ban_history = res;
            }

            self.emitStatus();
            return true;
        })
        .catch(function(err) {
            console.warn("updateUserBanHistory: FAILURE", err);
            let author = find(authors,{id:user_id});
            let ltiUser = find(ltiUsers,{id:user_id});
            if (author) {
                author.ban_history = [];
            }

            if (ltiUser) {
                ltiUser.ban_history = [];
            }

        });
//        .finally(function() {
//            self.emitStatus();
//        });
    },

    onGetOverviewStatsCompleted: function(actionId, stats) {
        action = { id: actionId };
        overviewStats = stats;
        this.emitStatus();
    },

    onGetOverviewStatsFailed: function(actionId, err) {
        overviewStats = null;
        action = { id: actionId };
        switch (err.status) {
            case 403:
                action.error = new ForgeError({ message: "Forbidden" });
                break;
            case 422:
                action.error = new ForgeError({ message: "Invalid input" });
                break;
            default:
                action.error = new ForgeError({ message: "Internal server error. Unable to fetch users. Please try again later." });
        }

        this.emitStatus();
    },
    
    onGetLmsDeploymentsCompleted: function(actionId, userId, res) {
        lmsDeployments[userId] = res; // indication that we tried and failed
        this.emitStatus();
    },

    onGetLmsDeploymentsFailed: function(actionId, userId, err) {
        console.warn("getLmsDeployments FAILURE", err);
        action = { id: actionId, error: err };
        lmsDeployments[userId] = []; // indication that we tried and failed
        this.emitStatus();
    },

    onGetLaunchCountsCompleted: function(actionId, userId, res) {
        action = { id: actionId };
        launchCounts[userId] = res.launch_count;
        this.emitStatus();
    },

    onGetLaunchCountsFailed: function(actionId, userId, err) {
        console.warn("getLaunchCounts FAILURE", err);
        action = { id: actionId, error: err };
        launchCounts[userId] = -1; // indication that we tried and failed
        this.emitStatus();
    },

    onRegisterOrganizationCompleted: function(actionID, res) {
        // console.log("onRegisterOrganizationCompleted: ", actionID, res);
        action = { id: actionID };
        orgs.push(res);
        this.emitStatus();
    },

    onGetAuthorsCompleted: function(actionId, res) {
        // console.log('onGetAuthorsCompleted: ', actionId, res);
        action = { id: actionId };
        authors = res.users;

        userPagination['authors'].totalRecords = res.totalUsers;
        userPagination['authors'].searchTerm = res.parsedUserSearch;
        userPagination['authors'].recordsPerPage = res.usersPerPage;
        userPagination['authors'].currentPage = 1;
        userPagination['authors'].numPages = 1;
        userPagination['authors'].filterPages = 1;
        if (res.totalUsers >  res.users.length) {
            userPagination['authors'].currentPage = res.parsedUserPage;
            userPagination['authors'].numPages = Math.ceil(res.totalUsers / res.usersPerPage);
            userPagination['authors'].filterPages = Math.ceil(res.matchingUsers / res.usersPerPage);
        }

        initializedAuthors = true;
        initialized = initializedAuthors && initializedLtiUsers;
        this.emitStatus();
    },

    onGetAuthorsFailed: function(actionId, err) {
        console.warn('onGetAuthorsFailed: ', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetOrgsCompleted: function(actionId, res) {
        // console.log('onGetOrgsCompleted: ', actionId, res);
        action = { id: actionId };
        orgs = res.users;

        userPagination['orgs'].totalRecords = res.totalUsers;
        userPagination['orgs'].searchTerm = res.parsedUserSearch;
        userPagination['orgs'].recordsPerPage = res.usersPerPage;
        userPagination['orgs'].currentPage = 1;
        userPagination['orgs'].numPages = 1;
        userPagination['orgs'].filterPages = 1;
        if (res.totalUsers >  res.users.length) {
            userPagination['orgs'].currentPage = res.parsedUserPage;
            userPagination['orgs'].numPages = Math.ceil(res.totalUsers / res.usersPerPage);
            userPagination['orgs'].filterPages = Math.ceil(res.matchingUsers / res.usersPerPage);
        }

        this.emitStatus();
    },

    onGetOrgsFailed: function(actionId, err) {
        console.warn('onGetOrgsFailed: ', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetLTIUsersCompleted: function(actionId, res) {
        // console.log('onGetLTIUsersCompleted: ', actionId, res);
        action = { id: actionId };
        ltiUsers = res.users;

        userPagination['ltiUsers'].totalRecords = res.totalUsers;
        userPagination['ltiUsers'].searchTerm = res.parsedUserSearch;
        userPagination['ltiUsers'].recordsPerPage = res.usersPerPage;
        userPagination['ltiUsers'].currentPage = 1;
        userPagination['ltiUsers'].numPages = 1;
        userPagination['ltiUsers'].filterPages = 1;
        if (res.totalUsers >  res.users.length) {
            userPagination['ltiUsers'].currentPage = res.parsedUserPage;
            userPagination['ltiUsers'].numPages = Math.ceil(res.totalUsers / res.usersPerPage);
            userPagination['ltiUsers'].filterPages = Math.ceil(res.matchingUsers / res.usersPerPage);
        }

        initializedLtiUsers = true;
        initialized = initializedAuthors && initializedLtiUsers;
        this.emitStatus();
    },

    onGetLTIUsersFailed: function(actionId, err) {
        console.warn('onGetLTIUsersFailed: ', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetChannelRolesCompleted: function(actionId, user_id, res) {
        action = { id: actionId };
        userChannelRoles[user_id] = {
            channel_roles: res
        };
        this.emitStatus();
    },

    onGetChannelRolesFailed: function(actionId, user_id, err) {
        console.warn('onGetChannelRolesFailed: ', actionId, err);
        action = { id: actionId, error: err };
        userChannelRoles[user_id] = {
            channel_roles: [],
            error: true,
        };
        this.emitStatus();
    },
    
    getEmulatedUserInfo: function() {
        const self = this;
        ServerRequest.makeRequest(`/authoring/users?userType=${Globals.users.type.EXTERNAL}`, 'GET')
        .then(res => {
            emulated3pUserInfo = res;
            self.emitStatus();
        })
        .catch(err => {
            console.warn('getEmulatedUserInfo failed:', err);
        });
    },

    onEmulate3pCompleted: function(actionId, userInfo) {
        // console.log('onEmulate3pCompleted:', actionId, userInfo);
        action = { id: actionId };
        emulated3pUserInfo = userInfo;
        this.emitStatus();
    },

    onEmulate3pFailed: function(actionId, err) {
        console.warn('onEmulate3pFailed:', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onClearEmulate3p: function(actionId) {
        action = { id: actionId };
        emulated3pUserInfo = {};
        this.emitStatus();
    },

    onDeleteUserCompleted: function(actionId, userId, res) {
        // console.log('onDeleteUserCompleted:', actionId, res);
        action = { id: actionId };
        authors = reject(authors, { id: userId });
        ltiUsers = reject(ltiUsers, { id: userId });
        this.emitStatus();
    },

    onDeleteUserFailed: function(actionId, err) {
        console.warn('onDeleteUserFailed:', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onResendRegistrationVerificationCompleted: function(actionId, userId, res) {
        // console.log('onResendRegistrationVerificationCompleted:', actionId, userId, res);
        action = { id: actionId };
        this.emitStatus();
    },

    onResendRegistrationVerificationFailed: function(actionId, userId, err) {
        console.warn('onResendRegistrationVerificationFailed:', actionId, userId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    
    
    onGetAdminStudentFeedbackCompleted: function(actionId, res) {
        // console.log('onGetAdminStudentFeedbackCompleted: ', actionId, res);
        action = { id: actionId };
        feedback_comments = res.records;
        studentFeedbackPagination.totalRecords = res.totalRecords;
        studentFeedbackPagination.commentSearchTerm = res.commentSearchTerm;
        studentFeedbackPagination.categorySearchTerm = res.categorySearchTerm;
        studentFeedbackPagination.sortBy = res.sortBy;
        studentFeedbackPagination.recordsPerPage = res.recordsPerPage;
        studentFeedbackPagination.currentPage = 1;
        studentFeedbackPagination.numPages = 1;
        studentFeedbackPagination.filterPages = 1;
        studentFeedbackPagination.matchingRecords = res.totalRecords;
        if (res.totalRecords >  res.records.length) {
            studentFeedbackPagination.matchingRecords = res.records.length;
            studentFeedbackPagination.currentPage = res.currentPage;
            studentFeedbackPagination.numPages = Math.ceil(res.totalRecords / res.recordsPerPage);
            studentFeedbackPagination.filterPages = Math.ceil(res.matchingRecords / res.recordsPerPage);
        }
        initializedFeedbackComments = true;
        this.emitStatus();
    },

    onGetAdminStudentFeedbackFailed: function(actionId, err) {
        console.warn('onGetAdminStudentFeedbackFailed: ', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    
    onUpdateAdminStudentFeedbackCompleted: function(actionId, res) {
        //console.log('onUpdateAdminStudentFeedbackCompleted: ', actionId, res);
        action = { id: actionId };
        forEach(res,(update)=>{
            let entry = find(feedback_comments,{id:update.id});
            if (entry) {
                if (update.category_id) {
                    entry.category_id = update.category_id;
                }
            }
        })
        this.emitStatus();
    },

    onUpdateAdminStudentFeedbackFailed: function(actionId, err) {
        console.warn('onUpdateAdminStudentFeedbackFailed: ', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onAdminUpdateUserCompleted: function(actionId, userId, res) {
        // console.log('onUpdateUserCompleted: ', actionId, userId, res);
        action = { id: actionId };
        let found = false;
        authors = authors.map((author) => {
            if (found || author.id != userId) return author;

            found = true;
            return res;
        });
        if (!found) {
            ltiUsers = ltiUsers.map((ltiUser) => {
                if (found || ltiUser != userId) return ltiUser;

                found = true;
                return res;
            });
        }

        if (!found) {
            orgs = orgs.map((org) => {
                if (found || org.id != userId) return org;

                found = true;
                return res;
            })
        }

        this.emitStatus();
    },

    onAdminUpdateUserFailed: function(actionId, userId, err) {
        console.warn('onUpdateUserFailed: ', actionId, userId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
});

module.exports = AdminGlobalUserStore;